import { Injectable } from '@angular/core';
import { countriesCdEnum } from '@shared/enums/countries-cd.enum';
import { GetSicForLocationModel, LocationGetQueryModel, LocationModel, LocationResponseModel } from '@shared/models/location.model';
import { GetSicForPostalCodesQuery, GetSicForPostalCodesResp } from '@xpo-ltl-2.0/sdk-location';
import { ManualRatingPro } from '@xpo-ltl-2.0/sdk-rating';

@Injectable({
  providedIn: 'root'
})
export class LocationApiMapperService {

  constructor() { }

  getRequest(location: LocationModel): LocationGetQueryModel {
    const requestQuery = new LocationGetQueryModel();
    requestQuery.usCa = this.getUsCaRequest(location);
    requestQuery.mx = this.getMexicoRequest(location)

    return requestQuery;
  }

  getResponse(locationUsCaResp: GetSicForPostalCodesResp, locationMxResp: GetSicForPostalCodesResp): LocationResponseModel {    
    return {
      postalSicAssignments: [...locationUsCaResp?.postalSicAssignments || [], ...locationMxResp?.postalSicAssignments || []],
      validationErrors: [...locationUsCaResp?.validationErrors || [], ...locationMxResp?.validationErrors || []]
    }
  } 

  getLocation(manualRatingPro: ManualRatingPro): LocationModel {
    const zipCode = manualRatingPro.ratingInformation?.consigneeZip6;
    const country = manualRatingPro.ratingInformation?.consigneeCountryCd;
    let countryCd;
    if (country === countriesCdEnum.usCa) {
      countryCd = countriesCdEnum.usCa;
    } else if (country === countriesCdEnum.us) {
      countryCd = countriesCdEnum.us
    } else if (country === countriesCdEnum.ca) {
      countryCd = countriesCdEnum.ca
    } else if (country === countriesCdEnum.cn) {
      countryCd = countriesCdEnum.cn
    } else if (country === countriesCdEnum.mx) {
      countryCd = countriesCdEnum.mx
    }

    const destLocation: GetSicForLocationModel = {
      countryCode: countryCd,
      postalCode: zipCode
    }
    return { destLocation };
  }

  private getUsCaRequest(location: LocationModel): GetSicForPostalCodesQuery {
    const originLocation = location?.originLocation?.countryCode === countriesCdEnum.usCa ? location.originLocation : undefined;
    const destLocation = location?.destLocation?.countryCode === countriesCdEnum.usCa ? location.destLocation : undefined;

    if (!originLocation && !destLocation) return;

    const request = new GetSicForPostalCodesQuery();

    request.postalCds = [
      originLocation?.postalCode,
      originLocation?.postalCode !== destLocation?.postalCode ? destLocation?.postalCode : undefined
    ];

    return request;
  }

  private getMexicoRequest(location: LocationModel): GetSicForPostalCodesQuery {
    const originLocation = location?.originLocation?.countryCode === countriesCdEnum.mx ? location.originLocation : undefined;
    const destLocation = location?.destLocation?.countryCode === countriesCdEnum.mx ? location.destLocation : undefined;
    if (!originLocation && !destLocation) return;

    const request = new GetSicForPostalCodesQuery();

    request.postalCds = [ originLocation?.postalCode, destLocation?.postalCode ];
    request.countryCds = [ originLocation?.countryCode, destLocation?.countryCode ];

    return request;
  }

  getGcdRequest(location: LocationModel): LocationGetQueryModel {
    const destLocation = location?.destLocation;

    const request = new GetSicForPostalCodesQuery();
    request.postalCds = [ destLocation?.postalCode ];
    request.countryCds = [ destLocation?.countryCode ];

    const requestQuery = new LocationGetQueryModel();
    requestQuery.usCa = request;
    requestQuery.mx = this.getMexicoRequest(location);

    return requestQuery;
  }
}
